import ApiPaths from "./ApiPaths";
import { httpService } from "./HttpService";
import axios from 'axios';

export interface DemoFormData {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    phone?: string;
    brands: string[];
    goodsInOperators: string;
    preferredTime?: string;
}

export const submitDemoRequest = async (data: DemoFormData): Promise<void> => {
    try {
        await httpService.post(ApiPaths.DEMO, data);
    } catch (error) {
        let errorMessage = 'Unexpected error happened, try again later.';
        if (axios.isAxiosError(error)) {
            errorMessage = error.response?.data?.userMessage ||
                           error.response?.data?.detail ||
                           errorMessage;
        }
        throw new Error(errorMessage);
    }
};
